export const DIFFICULTY = Object.freeze({
  BASIC: 'basic',
  FORTGESCHRITTEN: 'fortgeschritten',
  EXPERTE: 'experte',
});